import type {ErrorMessage} from 'angular-error-repository';

export const SelectItemError: ErrorMessage = () => {
    return 'Error.Select an item from the dropdown';
};
